import axios from "axios";
import { apiUrl } from '../constants/const';

export const invokeCloudRun = async () => {
    try {
      await axios.get(`${apiUrl}/admin/invoke`);
    } catch (err) {}
  };
